// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeblocks-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}
/* @media (min-width: 577px) {
  .card-center {
    position: relative;
    top: 100px;
  }
} */
/* container-level styling for the entire timeblocks component */
.timeblocks-container {
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  background: #ffffff;
  padding: 0.75rem 1rem;
}

.day-label .rounded {
  border: 1px solid #00b140;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* Fixed-width label column on desktop so all rows align */
.day-label {
  flex: 0 0 170px;
}

.slots-container {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.slot {
  width: 100px;
  min-width: 184px;
  font-size: 14px;
  flex: 0 0 auto;
  box-sizing: border-box;
  border: 1px solid #00b140;
  background-clip: padding-box;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: box-shadow 150ms ease, transform 120ms ease;
}

.slot:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-3px);
}

.slot.bg-success,
.slot.bg-success:hover {
  box-shadow: 0 8px 24px rgba(0, 176, 64, 0.18);
}

@media (max-width: 576px) {
  .timeblocks-row {
    flex-direction: column;
    align-items: stretch;
  }

  .day-label {
    margin-right: 0 !important;
    width: 100%;
    flex: 0 0 auto;
  }

  .day-label .rounded {
    width: 100%;
    box-sizing: border-box;
  }

  .slots-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* Mobile: two columns (col-6) */
  .slots-container .slot {
    /* flex: 0 0 50%; */
    max-width: 50%;
    /* min-width: 0; */
    box-sizing: border-box;
  }

  .slot {
    min-width: 230px;
    flex: 0 0 auto;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/timeblocks/timeblocks.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;GAKG;AACH,gEAAgE;AAChE;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,0DAA0D;AAC1D;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,cAAc;AAClB;AACA","sourcesContent":[".timeblocks-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n/* @media (min-width: 577px) {\n  .card-center {\n    position: relative;\n    top: 100px;\n  }\n} */\n/* container-level styling for the entire timeblocks component */\n.timeblocks-container {\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  background: #ffffff;\n  padding: 0.75rem 1rem;\n}\n\n.day-label .rounded {\n  border: 1px solid #00b140;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n/* Fixed-width label column on desktop so all rows align */\n.day-label {\n  flex: 0 0 170px;\n}\n\n.slots-container {\n  flex: 1 1 auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.slot {\n  width: 100px;\n  min-width: 184px;\n  font-size: 14px;\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  border: 1px solid #00b140;\n  background-clip: padding-box;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  transition: box-shadow 150ms ease, transform 120ms ease;\n}\n\n.slot:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  transform: translateY(-3px);\n}\n\n.slot.bg-success,\n.slot.bg-success:hover {\n  box-shadow: 0 8px 24px rgba(0, 176, 64, 0.18);\n}\n\n@media (max-width: 576px) {\n  .timeblocks-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .day-label {\n    margin-right: 0 !important;\n    width: 100%;\n    flex: 0 0 auto;\n  }\n\n  .day-label .rounded {\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .slots-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  /* Mobile: two columns (col-6) */\n  .slots-container .slot {\n    /* flex: 0 0 50%; */\n    max-width: 50%;\n    /* min-width: 0; */\n    box-sizing: border-box;\n  }\n\n  .slot {\n    min-width: 230px;\n    flex: 0 0 auto;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
